/**
 * 需求发布服务
 */

import { httpClient } from '../httpClient';
import { API_ENDPOINTS } from './config';

export interface DemandItem {
  id: number;
  title: string;
  description: string;
  demandType: 'supply' | 'demand';
  category?: string;
  industry?: string;
  technology?: string;
  companyName?: string;
  contactPerson?: string;
  contactPhone?: string;
  contactEmail?: string;
  keywords?: string;
  status: number;
  viewCount?: number;
  publishTime?: string;
  sortOrder?: number;
}

export interface DemandListParams {
  current?: number;
  size?: number;
  keyword?: string;
  demandType?: string;
  category?: string;
  industry?: string;
  status?: string;
}

const demandService = {
  async getList(params: DemandListParams) {
    return httpClient.get(API_ENDPOINTS.DEMAND?.LIST || '/api/biz/demand/list', {
      params
    });
  },

  async getById(id: number) {
    return httpClient.get(`${API_ENDPOINTS.DEMAND?.DETAIL || '/api/biz/demand'}/${id}`);
  },

  async create(data: Partial<DemandItem>) {
    return httpClient.post(API_ENDPOINTS.DEMAND?.CREATE || '/api/biz/demand', data);
  },

  async update(data: Partial<DemandItem>) {
    return httpClient.put(API_ENDPOINTS.DEMAND?.UPDATE || '/api/biz/demand', data);
  },

  async delete(id: number) {
    return httpClient.delete(`${API_ENDPOINTS.DEMAND?.DELETE || '/api/biz/demand'}/${id}`);
  },

  async batchDelete(ids: number[]) {
    return httpClient.delete(`${API_ENDPOINTS.DEMAND?.BATCH_DELETE || '/api/biz/demand/batch'}`, { data: ids });
  },

  async publish(id: number) {
    return httpClient.put(`${API_ENDPOINTS.DEMAND?.DETAIL || '/api/biz/demand'}/${id}/publish`);
  },

  async offline(id: number) {
    return httpClient.put(`${API_ENDPOINTS.DEMAND?.DETAIL || '/api/biz/demand'}/${id}/offline`);
  }
};

export default demandService;

